<template>
  <b-row align-h="center">
    <b-col lg="10" cols="12">
      <slot/>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'ContainerSmall'
}
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/ui/ContainerSmall.vue